import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getInvalidEndpoints } from '../../services';

export const useGetWhiteListUrls = (): UseQueryResult<string[], Error> => {
  return useQuery({
    queryKey: ['get_invalid_endpoints'],
    queryFn: getInvalidEndpoints,
    retry: 1,
    select: data => {
      if (data && data.length > 0) {
        // Only return a list of URLs
        return data.map(({ url }) => url);
      }

      return [];
    },
    refetchOnWindowFocus: false,
  });
};
